module.exports = __webpack_public_path__ + "img/yellowWarning.2dde0948.svg";